import React, { Component } from 'react';
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';
import gtag, { install } from 'ga-gtag';

// ユーザー特定のための乱数生成
const l = 16;
const c = "abcdefghijklmnopqrstuvwxyz0123456789";
const cl = c.length;
let r = "";
for(let i=0; i<l; i++) {
  r += c[Math.floor(Math.random()*cl)];
}
const uuid = r

export default class Web extends Component {

  componentDidMount () {
    if (this.props.match.params.section) {
      window.scrollTo(0, 100);
    }
    if ("30min.page" === document.domain) {
      ReactGA.initialize('UA-184751599-1', {gaOptions: {userId: uuid}});
      ReactGA.pageview(window.location.pathname + window.location.search);

      install('AW-404081375');
      gtag('config', 'AW-404081375');
      
      ReactPixel.init('750234562329469');
      ReactPixel.pageView();
    }
  }

  send() {
    //window.location.href = "http://30min-7085787.hs-sites.com/%E5%AE%9A%E6%9C%9F%E5%A5%91%E7%B4%84%E7%94%B3%E8%BE%BC-0";
    this.props.history.push({
      pathname: "/mjpm_form",
      state: { uuid: uuid }
    });
  }

  render () {
    return (
    <div className="web home">
      <div className="content-wrapper">
        <div className="trial-web">

          <div className="kv">
            <img src="/images/lp/trial/kv_web.png" alt="日々の家事。私たちと、ときどき、交代しませんか。" />
          </div>

          <div className="statement-wrapper">
            <div className="statement">
              <p>家事代行と聞くと、少し抵抗のある方、多いのではないでしょうか。</p>
              <p>私たちは、家事代行を、もっと気軽にしたいという想いから、</p>
              <p>新しいサービスをめざしています。</p>
              <p>｢ときどき家事を交代する｣という感覚で、気軽に体験してみませんか？</p>
            </div>
          </div>

          <div className="cv-button">
            <button onClick={this.send.bind(this)}>お申し込みはこちら</button>
          </div>

          <div className="content bottom-space">
            <img src="/images/lp/trial/campaign_price_web.png" alt="お試しキャンペーン特典　1回あたり2750円×4週　最大6600円お得！" />
          </div>

          <div className="content">
            <p className="content-title">お客様の声</p>
            <div className="user-voices">
              <div className="user-voice">
                <img src="/images/lp/trial/user_sa.png" alt="" />
                <p className="profile">港区在住・会社員・Sさん</p>
                <p className="comment">常に、お掃除が出来ていないという後ろめたい気持ちを持って生活していましたが、気持ちの負担が軽減され、ゆとりが生まれました。夜子供が寝た後の家事が無くなりゆっくりする時間が増えたり、家事に関する夫婦間の喧嘩が減ったのが嬉しいですね。</p>
              </div>
              <div className="user-voice">
                <img src="/images/lp/trial/user_ko.png" alt="" />
                <p className="profile">新宿区在住・自営業・Kさん</p>
                <p className="comment">これまでは汚れを見ると、早く掃除しなくてはと焦りを感じてしましたが、金曜日に家事代行が来てくれるから大丈夫だと少し気持ちに余裕を持てるようになりました。お風呂掃除担当の主人も負担が軽くなったと喜んでいました。</p>
              </div>
              <div className="user-voice">
                <img src="/images/lp/trial/user_kk.png" alt="" />
                <p className="profile">中央区在住・会社員・Kさん</p>
                <p className="comment">水回りを綺麗に維持する事が出来ています。 今まで気がつかなかった所も掃除してもらえて、気持ちが良いです。水回りのお掃除が常に心の負担でしたので、その負担が軽減されています。</p>
              </div>
              <br className="clear" />
            </div>
          </div>

          <div className="cv-button">
            <button onClick={this.send.bind(this)}>お申し込みはこちら</button>
          </div>

          <div className="content">
            <p className="content-title">三菱地所の新しい家事代行は、<br />こんなライフシーンをかなえます。</p>
            <div className="life-styles">
              <div className="life-style">
                <img src="/images/lp/trial/life-style1.png" alt="[LIFE STYLE1]" />
                <p className="life-style-title">心が整う</p>
                <p>平日のどこか一日だけでも、家に帰って掃除しなくていい日があるだけで、会社帰りの電車も気持ちが軽くなる。</p>
              </div>
              <div className="life-style">
                <img src="/images/lp/trial/life-style2.png" alt="[LIFE STYLE2]" />
                <p className="life-style-title">家事をバトンタッチ</p>
                <p>仕事も家事も子育てもがんばりたい。でも「たまに」でいいから、家事をバトンタッチできると、自分の自由な時間が増える。</p>
              </div>
              <br className="clear" />
            </div>
          </div>

          <div className="content">
            <div className="recommends-wrapper">
              <div className="recommends">
                <p className="content-title">こんな想いの人にオススメ！！</p>
                <div className="recommend">
                  <img src="/images/lp/trial/recommend1.png" alt="" />
                  <p>子育てと仕事を両立！<br />家事をアウトソースして、<br />子供と過ごす時間を作りたい方</p>
                  <br className="clear" />
                </div>
                <div className="recommend">
                  <img src="/images/lp/trial/recommend4.png" alt="" />
                  <p>テレワーク環境改善！<br />散らかった部屋が気になって、<br />仕事に集中できないなと思った事がある方</p>
                  <br className="clear" />
                </div>
                <div className="recommend">
                  <img src="/images/lp/trial/recommend2.png" alt="" />
                  <p>家でゆっくり過ごしたい！<br />家事が体力的に辛く、<br />カラダを休ませたいと思った事がある方</p>
                  <br className="clear" />
                </div>
                <br className="clear" />
              </div>
            </div>
          </div>

          <div className="cv-button">
            <button onClick={this.send.bind(this)}>お申し込みはこちら</button>
          </div>

          <div className="content">
            <div className="message">
              <div className="message-title">
                <img src="/images/lp/trial/message.png" alt="" />
              </div>
              <p>今の家事代行のイメージを変え、誰もが気軽に家事代行を利用できるように。様々な視点から家事代行を見つめ直していくプロジェクトです。</p>
            </div>
          </div>

          <div className="precautions">
            <div className="precaution">
              <p className="precaution-title">【キャンペーンのご利用について】</p>
              <p>●お客様からのお申込後、事務局よりメールにて、サービス開始日や訪問キャスト等の詳細をご連絡させて頂きます。</p>
              <p>●お客様のお住いの場所、ご希望の曜日や時間帯等によっては、サービスの提供までお待ちいただく場合や、サービスの提供自体を致し兼ねる場合がございます。予めご了承下さい。</p>
              <p>●今後、新型コロナウィルス感染症の感染拡大の状況によっては、内容等変更させて頂く場合がございます。</p>
            </div>
            <div className="precaution">
              <p className="precaution-title">【ご利用にあたってのお願い】</p>
              <p>●<a href="https://f.hubspotusercontent30.net/hubfs/7085787/%E5%88%A9%E7%94%A8%E8%A6%8F%E7%B4%84%E2%80%97%E6%B3%95%E4%BA%BA%E8%BF%BD%E5%8A%A0%E6%9C%80%E7%B5%82%E7%89%88.pdf" target="_blank" rel="noopener noreferrer">利用規約</a>をご確認下さい。</p>
              <p>●<a href="https://f.hubspotusercontent30.net/hubfs/7085787/%E3%82%AD%E3%83%A3%E3%83%B3%E3%82%BB%E3%83%AB%E3%83%9D%E3%83%AA%E3%82%B7%E3%83%BC-1.pdf" target="_blank" rel="noopener noreferrer">キャンセルポリシー</a>をご確認下さい。</p>
              <p>●本サービスは、現在、事業化検証中のサービスとなることをご了承ください。今後、諸般の事情により、サービス内容に変更等が生じる可能性がございます。</p>
            </div>
            <div className="precaution">
              <p className="precaution-title">【サービス提供日について】</p>
              <p>●祝日はサービス提供を原則お休みさせて頂きます。祝日においてもご利用をご希望される場合は事前に事務局へご相談下さい。</p>
            </div>
            <div className="precaution">
              <p className="precaution-title">【お支払いについて】</p>
              <p>●サービスご利用時に、都度クレジットカードにて決済させて頂きます。尚、決済については、サービス完了を事務局が確認したタイミングで実施され、サービスご利用日から３営業日内での決済を予定しています。</p>
            </div>
            <div className="precaution">
              <p className="precaution-title">【キャンペーンご利用後の継続利用について】</p>
              <p>当社は個人情報等に関する法令及びガイドライン等を遵守して、個人情報等の適正な取り扱いを行います／本フォームで取得した情報は当社の家事代行サービスに係るサービス提供・事業検証・事業化検証の為のアンケートやインタビュー依頼の目的で利用させて頂きます／当社は上記に記載の目的の達成に必要な範囲で当社グループ会社等と個人情報を共同利用することがあります。その場合の個人情報は登録フォームの全ての項目となり、管理責任の所在は、当社となります／ご登録者様から頂いた情報については、守秘義務を締結の上、三菱地所から業務委託を行っている外部の担当者等と共有させて頂く可能性がございます／事業化検証の経過・結果の一部として本フォーム登録結果を外部に開示する可能性がありますが、その場合、個人を特定されない形に集計して利用致します。</p>
              <p>当社は、上記に記載のほか、下記に記載の利用目的の達成に必要な範囲で、三菱地所プロパティマネジメント（株）と個人情報を共同利用することがあります。その場合の個人情報の項目は氏名、住所、性別、家族構成、サービス申込実績、サービス利用実績、アンケート・インタビュー結果となります。</p>
              <p>＜利用目的＞</p>
              <p>・申込者・利用者の属性や申込・利用状況を把握する為</p>
              <p>・利用者のサービス利用に関する満足度や使い勝手等のフィードバックにより、品質向上を図る為</p>
              <p>※本件及び本件に係る個人情報の取り扱いについてのお問い合わせ先三菱地所株式会社・住宅業務企画部 中村・松沢 thirty-min@mec.co.jp</p>
            </div>
          </div>

          <div className="cv-button">
            <button onClick={this.send.bind(this)}>お申し込みはこちら</button>
          </div>

          <div className="footer">
            <p className="footer-title">直接のお問い合わせはこちら</p>
            <p className="contact-department-title">三菱地所株式会社 住宅業務企画部</p>
            <p className="contact-department">（家事代行実証実験事務局）</p>
            <p className="contact-mail">thirty-min@mec.co.jp</p>
            <p className="contact-tel">03-3287-3384／03-3287-7706</p>
          </div>

        </div>
      </div>
    </div>
    );
  }
}